import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { setPageMeta } from "@/lib/api";
import { Splatter } from "@/components/Splatter";
import { Layers, Sparkles, Boxes, Cog, Upload, FileText, ArrowRight, Type } from "lucide-react";

const META = {
  "lithophanies": { icon: Layers, img: "/images/lithophane_lamp.jpeg", desc: "Transformez vos plus belles photos en lampes lithophanies lumineuses et émouvantes." },
  "figurines": { icon: Sparkles, img: "/images/fig_sangoku.jpg", desc: "Personnages, dragons, créatures — des figurines détaillées pour la déco, le jeu ou la collection." },
  "ecriture-3d": { icon: Type, img: "/images/ecriture_3d.jpg", desc: "Lettres et textes 3D à coller ou poser : boîte aux lettres, murs, meubles… en TPU, police au choix." },
  "objets-personnalises": { icon: Boxes, img: "/images/custom_keychain.jpeg", desc: "Porte-clés, supports, cadeaux uniques : personnalisez couleurs, texte et dimensions." },
  "pieces-techniques": { icon: Cog, img: "https://images.unsplash.com/photo-1740625940423-a59a65c753c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", desc: "Engrenages, boîtiers, prototypes fonctionnels imprimés en matériaux résistants." },
  "impression-fichier-3d": { icon: Upload, img: "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", desc: "Vous avez déjà votre modèle ? Envoyez votre STL / 3MF / OBJ / STEP, on s'occupe de l'impression.", to: "/impression-fichier-3d" },
  "demande-de-devis": { icon: FileText, img: "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", desc: "Projet spécial, grande série ou création sur mesure ? Demandez votre devis gratuit.", to: "/devis" },
};

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    setPageMeta("Catégories — Tenay Ain-Pression", "Lithophanies, figurines, objets personnalisés, pièces techniques, impression depuis fichier 3D et demande de devis.");
    api.get("/categories").then(({ data }) => setCats(data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">Catégories</h1>
          <p className="mt-3 text-gray-400 max-w-2xl">Tout ce que Tenay Ain-Pression peut créer pour vous.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-8 md:grid-cols-2">
        {cats.map((c, i) => {
          const m = META[c.slug] || {};
          const Icon = m.icon || Boxes;
          const to = m.to || `/boutique?category=${c.slug}`;
          return (
            <Link key={c.slug} to={to} data-testid={`cat-${c.slug}`}
              className="group card-hover fade-up relative overflow-hidden rounded-2xl border border-[#222] bg-[#0A0A0A] min-h-[260px] flex items-end"
              style={{ animationDelay: `${i * 70}ms` }}>
              <img src={m.img} alt={c.name}
                className="absolute inset-0 w-full h-full object-cover opacity-35 group-hover:opacity-55 group-hover:scale-105 transition-all duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
              <div className="relative p-7">
                <Icon className="w-9 h-9 text-[#E6007E]" />
                <h2 className="mt-3 font-heading text-2xl font-bold">{c.name}</h2>
                <p className="mt-2 text-gray-300 max-w-md">{m.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-[#0055FF] font-bold group-hover:gap-2 transition-all">
                  Explorer <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
